import React, { useState, useEffect } from 'react';
import { WifiOff } from 'lucide-react';

export const OfflineBanner = () => {
  const [offline, setOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const goOffline = () => setOffline(true);
    const goOnline = () => setOffline(false);
    window.addEventListener('offline', goOffline);
    window.addEventListener('online', goOnline);
    return () => {
      window.removeEventListener('offline', goOffline);
      window.removeEventListener('online', goOnline);
    };
  }, []);

  if (!offline) return null;

  return (
    <div className="fixed top-0 inset-x-0 z-[9997] bg-red-600 text-white py-2 px-4 text-center text-sm font-medium flex items-center justify-center gap-2"
      data-testid="offline-banner">
      <WifiOff className="w-4 h-4" />
      Brak połączenia z internetem. Sprawdź sieć.
    </div>
  );
};
